<template>
    <div>
        <form v-if="!success" id="EventKitOrderForm" @submit.prevent="submit" class="event-form">
            <div class="row clearfix">
                <div class="col-lg-6">
                    <h3>Event Details</h3>
                    <div class="row">
                        <div class="input-group">
                            <div class="col-lg-6">
                                <FormLabel :required="true" for="first-name">Location ID:</FormLabel>
                             </div>
                            <div class="col-lg-6">
                                <FormInput :class="{'is-invalid': validationErrors.location_id}" id="location-id" v-model="form.location_id"/>
                                <ValidationError v-if="validationErrors.location_id">{{ validationErrors.location_id }}</ValidationError>
                            </div>
                        </div>
                        <div class="input-group">
                            <div class="col-lg-6">
                                <FormLabel :required="true" for="requestors-name">Requestor's Name:</FormLabel>
                            </div>
                            <div class="col-lg-6">
                                <FormInput :class="{'is-invalid': validationErrors.requestors_name}" id="requestors-name" v-model="form.requestors_name"/>
                                <ValidationError v-if="validationErrors.requestors_name">{{ validationErrors.requestors_name }}</ValidationError>
                            </div>
                        </div>
                        <div class="input-group">
                            <div class="col-lg-6">
                                <FormLabel :required="true">Qty of Additional Pens Needed:</FormLabel>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-check form-check-inline pl-0 pt-0">
                                    <FormRadio class="form-check-input" :class="{'is-invalid': validationErrors.premium_quantity}" id="premium-quantity-50" value="50" v-model="form.premium_quantity"/>
                                    <label class="form-check-label" for="premium-quantity-50">50</label>
                                </div>
                                <div class="form-check form-check-inline pl-0 pt-0">
                                    <FormRadio class="form-check-input" :class="{'is-invalid': validationErrors.premium_quantity}" id="premium-quantity-100" value="100" v-model="form.premium_quantity"/>
                                    <label class="form-check-label" for="premium-quantity-100">100</label>
                                </div>
                                <ValidationError v-if="validationErrors.premium_quantity">{{ validationErrors.premium_quantity }}</ValidationError>
                            </div>
                        </div>
                        <div class="input-group">
                            <div class="col-lg-6">
                                <FormLabel :required="true" for="event-start-date">Event Start Date:</FormLabel>
                            </div>
                            <div class="col-lg-6">
                                <FormInput type="date" :class="{'is-invalid': validationErrors.event_start_date}" id="event-start-date" v-model="form.event_start_date"/>
                                <ValidationError v-if="validationErrors.event_start_date">{{ validationErrors.event_start_date }}</ValidationError>
                            </div>
                        </div>
                        <div class="input-group">
                            <div class="col-lg-6">
                                <FormLabel :required="true" for="event-end-date">Event End Date:</FormLabel>
                            </div>
                            <div class="col-lg-6">
                                <FormInput type="date" :class="{'is-invalid': validationErrors.event_end_date}" id="event-end-date" v-model="form.event_end_date"/>
                                <ValidationError v-if="validationErrors.event_end_date">{{ validationErrors.event_end_date }}</ValidationError>
                            </div>
                        </div>
                        <div class="input-group">
                            <div class="col-lg-6">
                                <FormLabel :required="true" for="anticipated-event-attendance">Anticipated Event Attendance:</FormLabel>
                            </div>
                            <div class="col-lg-6">
                                <FormInput :class="{'is-invalid': validationErrors.anticipated_event_attendance}" id="anticipated-event-attendance" v-model="form.anticipated_event_attendance"/>
                                <ValidationError v-if="validationErrors.anticipated_event_attendance">{{ validationErrors.anticipated_event_attendance }}</ValidationError>
                            </div>
                        </div>
                        <div class="input-group">
                            <div class="col-lg-6">
                                <FormLabel :required="true" for="first-name">Indoor or Outdoor Event:</FormLabel>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-check form-check-inline pl-0 pt-0">
                                    <FormRadio class="form-check-input" :class="{'is-invalid': validationErrors.indoor_outdoor_event}" id="ndoor-outdoor-event-in" value="indoor" v-model="form.indoor_outdoor_event"/>
                                    <label class="form-check-label" for="ndoor-outdoor-event-in">Indoor</label>
                                </div>
                                <div class="form-check form-check-inline pl-0 pt-0">
                                    <FormRadio class="form-check-input" :class="{'is-invalid': validationErrors.indoor_outdoor_event}" id="indoor-outdoor-event-out" value="outdoor" v-model="form.indoor_outdoor_event"/>
                                    <label class="form-check-label" for="indoor-outdoor-event-out">Outdoor</label>
                                </div>
                                <ValidationError v-if="validationErrors.indoor_outdoor_event">{{ validationErrors.indoor_outdoor_event }}</ValidationError>
                            </div>
                        </div>
                        <div class="input-group">
                            <div class="col-lg-6">
                                <FormLabel :required="true" for="kit-type">Event Kit Type:</FormLabel>
                            </div>
                            <div class="col-lg-6">
                                <FormSelect :class="{'is-invalid': validationErrors.kit_type}" id="kit-type" v-model="form.kit_type">
                                    <option value="small">Small Kit</option>
                                    <option value="large">Large Kit</option>
                                    <option value="outdoor">Outdoor Kit</option>
                                </FormSelect>
                                <ValidationError v-if="validationErrors.kit_type">{{ validationErrors.kit_type }}</ValidationError>
                            </div>
                        </div>
                        <div class="input-group">
                            <div class="col-lg-6">
                                <FormLabel :required="true" for="event-details">Describe Your Event:</FormLabel>
                            </div>
                            <div class="col-lg-6">
                                <textarea :class="{'is-invalid': validationErrors.event_details}" id="event-details" v-model="form.event_details"/>
                                <ValidationError v-if="validationErrors.event_details">{{ validationErrors.event_details }}</ValidationError>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <h3>Shipping Information</h3>
                    <div class="row">
                        <div class="input-group">
                            <div class="col-lg-6">
                                <FormLabel :required="true" for="name">Name:</FormLabel>
                            </div>
                            <div class="col-lg-6">
                                <FormInput :class="{'is-invalid': validationErrors.name}" id="name" v-model="form.name"/>
                                <ValidationError v-if="validationErrors.name">{{ validationErrors.name }}</ValidationError>
                            </div>
                        </div>
                        <div class="input-group">
                            <div class="col-lg-6">
                                <FormLabel :required="true" for="email">Email:</FormLabel>
                            </div>
                            <div class="col-lg-6">
                                <FormInput :class="{'is-invalid': validationErrors.email}" id="email" v-model="form.email"/>
                                <ValidationError v-if="validationErrors.email">{{ validationErrors.email}}</ValidationError>
                            </div>
                        </div>
                        <div class="input-group">
                            <div class="col-lg-6">
                                <FormLabel :required="true" for="phone">Phone:</FormLabel>
                            </div>
                            <div class="col-lg-6">
                                <FormInput :class="{'is-invalid': validationErrors.phone}" id="phone" v-model="form.phone"/>
                                <ValidationError v-if="validationErrors.phone">{{ validationErrors.phone}}</ValidationError>
                            </div>
                        </div>
                        <div class="input-group">
                            <div class="col-lg-6">
                                <FormLabel :required="true" for="branch-sales-office-name">Branch/Sales Office Name:</FormLabel>
                            </div>
                            <div class="col-lg-6">
                                <FormInput :class="{'is-invalid': validationErrors.branch_sales_office_name}" id="branch-sales-office-name" v-model="form.branch_sales_office_name"/>
                                <ValidationError v-if="validationErrors.branch_sales_office_name">{{ validationErrors.branch_sales_office_name}}</ValidationError>
                            </div>
                        </div>
                        <div class="input-group">
                            <div class="col-lg-6">
                                <FormLabel :required="true" for="shipping-address">Shipping Address:</FormLabel>
                            </div>
                            <div class="col-lg-6">
                                <FormInput :class="{'is-invalid': validationErrors.shipping_address}" id="shipping-address" v-model="form.shipping_address"/>
                                <ValidationError v-if="validationErrors.shipping_address">{{ validationErrors.shipping_address}}</ValidationError>
                            </div>
                        </div>
                        <div class="input-group">
                            <div class="col-lg-6">
                                <FormLabel :required="true" for="shipping-city">Shipping City:</FormLabel>
                            </div>
                            <div class="col-lg-6">
                                <FormInput :class="{'is-invalid': validationErrors.shipping_city}" id="shipping-city" v-model="form.shipping_city"/>
                                <ValidationError v-if="validationErrors.shipping_city">{{ validationErrors.shipping_city}}</ValidationError>
                            </div>
                        </div>
                        <div class="input-group">
                            <div class="col-lg-6">
                                <FormLabel :required="true" for="first-name">Shipping State:</FormLabel>
                            </div>
                            <div class="col-lg-6">
                                <FormSelect :class="{'is-invalid': validationErrors.shipping_state}" id="shipping-state" v-model="form.shipping_state">
                                    <option :value="state" v-for="state in states">{{ state }}</option>
                                </FormSelect>
                                <ValidationError v-if="validationErrors.shipping_state">{{ validationErrors.shipping_state }}</ValidationError>
                            </div>
                        </div>
                        <div class="input-group">
                            <div class="col-lg-6">
                                <FormLabel :required="true" for="shipping-zip">Shipping Zip:</FormLabel>
                            </div>
                            <div class="col-lg-6">
                                <FormInput :class="{'is-invalid': validationErrors.shipping_zip}" id="shipping-zip" v-model="form.shipping_zip"/>
                                <ValidationError v-if="validationErrors.shipping_zip">{{ validationErrors.shipping_zip }}</ValidationError>
                            </div>
                        </div>
                        <div class="input-group">
                            <div class="col-lg-6"></div>
                            <div class="col-lg-6 pt-3">
                                <FormButton :pending="pending" pendingText="Submitting">Order Event Kit</FormButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="errorMessage" class="mt-3 alert alert-danger">
                <p class="mb-0">{{ errorMessage }}</p>
            </div>
        </form>
        <EventKitOrderConfirmation v-else :order="order"/>
    </div>
</template>

<script>
import FormLabel from '@/components/form/FormLabel';
import FormInput from '@/components/form/FormInput';
import ValidationError from '@/components/form/ValidationError';
import FormMixin from '@/mixins/FormMixin';
import FormSelect from '@/components/form/FormSelect';
import { states } from '@/states';
import MarketingService from '@/services/marketing.service';
import FormButton from '@/components/form/FormButton';
import MarketingMaterialsOrderConfirmation from '@/components/marketing/MarketingMaterialsOrderConfirmation';

const DEFAULT = {
    location_id: '',
    requestors_name: '',
    premium_quantity: '',
    event_end_date: '',
    anticipated_event_attendance: '',
    indoor_outdoor_event: '',
    kit_type: '',
    event_start_date: '',
    event_details: '',
    name: '',
    email: '',
    phone: '',
    branch_sales_office_name: '',
    shipping_address: '',
    shipping_city: '',
    shipping_state: '',
    shipping_zip: '',
};

const EMPLOYEE = {
    first_name: '',
    last_name: '',
    email: '',
    location_code: '',
};

export default {
    components: {
        MarketingMaterialsOrderConfirmation,
        FormButton,
        FormLabel,
        FormSelect,
        FormInput,
        ValidationError
    },
    mixins: [
        FormMixin
    ],
    props: {
        employee: {
            type: Object,
            default() {
                return EMPLOYEE;
            }
        },
    },
    data() {
        return {
            states: states,
            form: {...DEFAULT, ...{
                requestors_name: `${this.employee.first_name} ${this.employee.last_name}`,
                location_id: this.employee.location_code,
             }}
        }
    },
    methods: {
        async submit() {
            this.pending = true;
            this.errorMessage = '';
            this.errorStatusCode = null;
            this.validationErrors = {};

            try {
                this.order = await MarketingService.eventKitOrder(this.form);
                this.success = true;
            } catch (error) {
                this.handleError(error);
            } finally {
                this.pending = false;
            }
        }
    }
}
</script>
